import { render } from "./feed-customer-card.vue?vue&type=template&id=340cba24&scoped=true"
import script from "./feed-customer-card.vue?vue&type=script&lang=js"
export * from "./feed-customer-card.vue?vue&type=script&lang=js"

import "./feed-customer-card.vue?vue&type=style&index=0&id=340cba24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340cba24"]])

export default __exports__